const VolunteerShiftList = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/ListPage.vue");
const VolunteerShiftDetail = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/FormPage.vue");
const VolunteerShiftIndex = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/IndexPage.vue");

export default [
  {
    path: "/volunteer_shift",
    component: VolunteerShiftIndex,
    redirect: "/volunteer_shift/list",
    name: "volunteer_shift",
    children: [
      {
        path: "list",
        component: VolunteerShiftList,
        name: "volunteer_shift.list",
      },
      {
        path: "create",
        component: VolunteerShiftDetail,
        name: "volunteer_shift.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: VolunteerShiftDetail,
        name: "volunteer_shift.edit",
        props: { create: false },
      },
    ],
  },
];
